import { render, staticRenderFns } from "./GruposTeacher.vue?vue&type=template&id=5261bc1f&scoped=true"
import script from "./GruposTeacher.vue?vue&type=script&lang=js"
export * from "./GruposTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5261bc1f",
  null
  
)

export default component.exports